// extracted by mini-css-extract-plugin
export default {"fill":"fill---Ggsoy","iconStart":"iconStart---hnw4i","iconEnd":"iconEnd---Bm363"};